import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Select, message } from "antd";
import { createService, updateService } from "../../http/serviceAPI"; // ✅ add updateService
import { fetchCategories } from "../../http/categoryAPI";

const { Option } = Select;

const ServiceForm = ({ onClose, onSuccess, service }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchCategories();
        setCategories(data);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        message.error("Could not load categories");
      }
    };
    loadCategories();
  }, []);

  // ✅ Prefill form if service exists
  useEffect(() => {
    if (service) {
      form.setFieldsValue({
        nameAM: service.nameAM,
        nameEN: service.nameEN,
        nameRU: service.nameRU,
        price: service.price,
        categoryId: service.categoryId,
      });
    }
  }, [service, form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      let response;

      if (service) {
        // ✅ Update existing service
        response = await updateService(service.id, values);
        message.success("Service updated successfully!");
      } else {
        // ✅ Create new service
        response = await createService(values);
        message.success("Service created successfully!");
      }

      if (onSuccess) onSuccess(response);
      if (onClose) onClose();
    } catch (error) {
      console.error("Error saving service:", error);
      message.error("Failed to save service.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{ price: 0 }}
    >
      <Form.Item
        label="Անուն (Հայերեն)"
        name="nameAM"
        rules={[{ required: true, message: "Please enter Armenian name" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Անուն (Անգլերեն)"
        name="nameEN"
        rules={[{ required: true, message: "Please enter English name" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Անուն (Ռուսերեն)"
        name="nameRU"
        rules={[{ required: true, message: "Please enter Russian name" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Արժեք"
        name="price"
        rules={[{ required: true, message: "Please enter a price" }]}
      >
        <InputNumber min={0} style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item
        label="Բաժին"
        name="categoryId"
        rules={[{ required: true, message: "Please select a category" }]}
      >
        <Select placeholder="Ընտրեք բաժինը">
          {categories.map((cat) => (
            <Option key={cat.id} value={cat.id}>
              {cat.nameEN}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {service ? "Թարմացնել Ծառայություն" : "Ստեղծել Ծառայություն"} {/* ✅ dynamic button text */}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ServiceForm;
